/**
 * Generic dialog for displaying a message with optional style based on type.
 * Props: open state, onClose, title and message.
 */

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const MessageDialog = ({ open, onClose, title, message, type }:any) => {
  const getColor = (type:any) => {
    switch (type) {
      case "error":
        return { titleColor: "red", buttonColor: "error", backgroundColor: "#f8d7da" };
      case "warning":
        return { titleColor: "orange", buttonColor: "warning", backgroundColor: "#fff3cd" };
      case "success":
        return { titleColor: "green", buttonColor: "success", backgroundColor: "#d4edda" };
      default:
        return { titleColor: "black", buttonColor: "primary", backgroundColor: "white" };
    }
  };

  const { titleColor, buttonColor, backgroundColor } = getColor(type);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: titleColor }}>{title}</DialogTitle>
      <DialogContent sx={{ backgroundColor }}>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" sx={{color:buttonColor}}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageDialog;
